import coreConfig from '../../core/config';
import routingConfig from '../../routing/config';
import deviseConfig from '../../devise/config';

export const getAppConfig = async ({ companyName } = {}) => {
  try {
    let result = null;
    if (companyName) {
      result = await import(`../../apps/${companyName}/config.jsx`);
    } else {
      result = await import('../../apps/marketing/config.jsx');
    }
    const { default: config } = result;
    return config;
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getConfigField = async ({ companyName, fieldName }) => {
  const config = await getAppConfig({ companyName });
  if (!config) return null;

  return config[fieldName];
};

const appListContainsApp = (list, appName) => {
  const found = list.find(app => {
    const { name } = app;
    return name === appName;
  });
  return found;
};

const ensureUniqueAppList = list => {
  const result = [];
  list.forEach(app => {
    const { name } = app;
    if (!appListContainsApp(result, name)) {
      result.push(app);
    }
  });
  return result;
};

export const getAppList = async ({ companyName }) => {
  const list = await getConfigField({ companyName, fieldName: 'appList' });
  let result = [coreConfig, routingConfig, deviseConfig];
  if (list) {
    result = result.concat(list);
  }
  return ensureUniqueAppList(result);
};

export const getCompanyTheme = async ({ companyName }) => {
  const config = await getAppConfig({ companyName });
  if (!config) return {};

  return config.theme;
};
